<template>
  <b-modal
    id="edit-requisite"
    size="lg"
    :title="requisite ? $t('generals.edit') : $t('generals.add')"
    :ok-title="$t('generals.save')"
    ok-variant="success"
    cancel-variant="danger"
    :cancel-title="$t('generals.cancel')"
    no-close-on-backdrop
    @ok="obSubmit"
  >
    <b-form-group
      :label="$t('clients.bank_account_type')"
      label-for="email"
    >
      <div class="d-flex align-items-center mt-50">
        <b-form-radio
          v-model="bank_requisite_type"
          class="mb-2"
          name="some-radios"
          :value="false"
        >
          {{ $t('clients.internal') }}
        </b-form-radio>

        <b-form-radio
          v-model="bank_requisite_type"
          class="mb-2 ml-4"
          name="some-radios"
          :value="true"
        >
          {{ $t('clients.external') }}
        </b-form-radio>
      </div>
    </b-form-group>

    <b-row v-if="!bank_requisite_type">
      <b-col md="4">
        <b-form-group
          :label="$t('clients.bank')"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="localRequisites.bank"
            type="text"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('clients.checking_account')"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="localRequisites.checking_account"
            type="text"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('clients.mfos')"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="localRequisites.mfo"
            type="text"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col md="4">
        <b-form-group
          :label="$t('clients.bank')"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="internalRequisites.bank"
            type="text"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('clients.acc')"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="internalRequisites.checking_account"
            type="text"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          label="SWIFT"
          label-for="item-name"
        >
          <b-form-input
            id="item-name"
            v-model="internalRequisites.mfo"
            type="text"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>

</template>

<script>
import {
  BModal, BRow, BCol, BFormInput, BFormGroup, BFormRadio,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  props: ['requisite'],
  data() {
    return {
      bank_requisite_type: false,
      internalRequisites: {
        bank: '',
        checking_account: '',
        mfo: '',
      },
      localRequisites: {
        bank: '',
        checking_account: '',
        mfo: '',
      },
    }
  },
  methods: {
    ...mapActions('clients', ['UPDATE_ONE_REQUISITE', 'FETCH_ONE_CLIENT', 'ADD_NEW_REQUISITE']),
    async obSubmit() {
      if (this.bank_requisite_type === true) {
        if (!this.requisite) {
          this.ADD_NEW_REQUISITE({
            type: 'internal',
            bank_requisite: this.internalRequisites,
            company: this.$route.params.id,
          })
        } else {
          await this.UPDATE_ONE_REQUISITE({
            id: this.requisite.id,
            data: {
              type: 'internal',
              bank_requisite: this.internalRequisites,
            },
          })
        }
      } else if (!this.requisite) {
        this.ADD_NEW_REQUISITE({
          type: 'local',
          bank_requisite: this.localRequisites,
          company: this.$route.params.id,
        })
      } else {
        await this.UPDATE_ONE_REQUISITE({
          id: this.requisite.id,
          data: {
            type: 'local',
            bank_requisite: this.localRequisites,
          },
        })
      }

      this.FETCH_ONE_CLIENT(this.$route.params.id)

      this.$nextTick(() => {
        this.$bvModal.hide('edit-requisite')
      })

      this.clearData()
    },
    clearData() {
      this.bank_requisite_type = false
      this.internalRequisites = {
        bank: '',
        checking_account: '',
        mfo: '',
      }
      this.localRequisites = {
        bank: '',
        checking_account: '',
        mfo: '',
      }
    },
  },
  watch: {
    requisite(newValue) {
      console.log(newValue, 'new')
      if (!newValue) {
        this.clearData()
      }
      const { type, bank_requisite } = newValue
      if (type === 'internal') {
        this.bank_requisite_type = true
        this.internalRequisites = {
          bank: bank_requisite.bank,
          checking_account: bank_requisite.checking_account,
          mfo: bank_requisite.mfo,
        }
      }

      this.bank_requisite_type = false
      this.localRequisites = {
        bank: bank_requisite.bank,
        checking_account: bank_requisite.checking_account,
        mfo: bank_requisite.mfo,
      }
    },
  },
  components: {
    BModal, BRow, BCol, BFormInput, BFormGroup, BFormRadio,

  },

}
</script>

<style>

</style>
